// =====================================================================
// NotificationsBell (Quadros PRO / Onda 2 / S60) — sino in-app dos Quadros.
// Socket por usuário + polling leve (fallback). Clicar abre o quadro.
// =====================================================================
import React, { useState, useEffect, useCallback, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { IconButton, Badge, Menu, MenuItem, Typography, Box, Button, Tooltip } from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { AuthContext } from "../../context/Auth/AuthContext";
import { listBoardNotifications, readBoardNotifications } from "../../services/boardService";

const NotificationsBell = () => {
  const { user, socket } = useContext(AuthContext);
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [anchor, setAnchor] = useState(null);
  const pollRef = useRef(null);

  const load = useCallback(async () => {
    try {
      const d = await listBoardNotifications(false);
      setItems((d && d.notifications) || []);
      setUnread((d && d.unread) || 0);
    } catch { /* silencioso */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    if (!socket || !user) return undefined;
    const evt = `company-${user.companyId}-board-notif-${user.id}`;
    const handler = () => load();
    socket.on(evt, handler);
    return () => socket.off(evt, handler);
  }, [socket, user, load]);

  useEffect(() => {
    pollRef.current = setInterval(load, 120000);
    return () => { if (pollRef.current) clearInterval(pollRef.current); };
  }, [load]);

  const openMenu = (e) => setAnchor(e.currentTarget);
  const closeMenu = () => setAnchor(null);

  const openItem = async (n) => {
    closeMenu();
    try { await readBoardNotifications(n.id); } catch { /* ignora */ }
    load();
    if (n.boardId) history.push(`/quadros/${n.boardId}`);
  };
  const markAll = async () => { try { await readBoardNotifications(); } catch { /* ignora */ } load(); };

  return (
    <>
      <Tooltip title="Notificações dos Quadros">
        <IconButton color="inherit" onClick={openMenu}>
          <Badge badgeContent={unread} color="secondary"><NotificationsIcon /></Badge>
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={!!anchor} onClose={closeMenu} getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
        <Box px={2} py={1} display="flex" alignItems="center" justifyContent="space-between" style={{ minWidth: 300 }}>
          <Typography variant="subtitle2">Notificações</Typography>
          {unread > 0 && <Button size="small" onClick={markAll}>Marcar lidas</Button>}
        </Box>
        {items.length === 0 ? (
          <MenuItem disabled><Typography variant="body2" color="textSecondary">Sem notificações.</Typography></MenuItem>
        ) : (
          items.slice(0, 15).map((n) => (
            <MenuItem key={n.id} onClick={() => openItem(n)}
              style={{ whiteSpace: "normal", maxWidth: 340, background: n.read ? undefined : "rgba(21,101,192,0.08)" }}>
              <Typography variant="body2">{n.body || n.type}</Typography>
            </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
};

export default NotificationsBell;
